import { Client } from "./client";
import {
  ProjectProcedureInstanceAssignmentListResponse,
  ProjectProcedureInstanceAssignmentResponse,
  CreateProjectProcedureInstanceAssignmentRequest
} from "@/backend/express/controllers/projectProcedureInstanceAssignmentController";
import { FusaReply } from "@/types/replyTypes";

export class ProjectProcedureInstanceAssignmentController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  getAssignmentsByProjectId(projectId: string): Promise<ProjectProcedureInstanceAssignmentListResponse> {
    return this.client.read(`/api/project-procedure-instance-assignments/project/${projectId}`);
  }

  createAssignment(data: CreateProjectProcedureInstanceAssignmentRequest): Promise<ProjectProcedureInstanceAssignmentResponse> {
    return this.client.create('/api/project-procedure-instance-assignments', data);
  }

  deleteAssignment(id: string): Promise<FusaReply> {
   return this.client.delete(`/api/project-procedure-instance-assignments/${id}`);
  }
}
